module.exports = __webpack_public_path__ + "img/device_alice.3d693df5.png";